import { Input, Search16 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchField = function SearchField(props) {
  var value = props.value,
      onChange = props.onChange;
  return /*#__PURE__*/_jsx(Input, {
    "data-testid": "search-input",
    leftEnhancer: /*#__PURE__*/_jsx(Search16, {}),
    placeholder: "\u041F\u043E\u0438\u0441\u043A",
    value: value,
    onChange: onChange
  });
};